import { GenericEditableObjectStoreFactory } from "../../../Common/_generics/GenericEditableObjectStoreFactory";

export const BaseEditableInvitationGroupStore = GenericEditableObjectStoreFactory(
    "EDITABLE_INVITATION_GROUP", null,
);